import { ReactNode, useState, useRef, useCallback } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

interface HoverPopoverProps {
  trigger: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  align?: "start" | "center" | "end";
}

export function HoverPopover({ trigger, children, contentClassName = "w-56 p-0", align = "end" }: HoverPopoverProps) {
  const [isOpen, setIsOpen] = useState(false);
  const closeTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleOpen = useCallback(() => {
    if (closeTimeout.current) {
      clearTimeout(closeTimeout.current);
      closeTimeout.current = null;
    }
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    closeTimeout.current = setTimeout(() => {
      setIsOpen(false);
    }, 150);
  }, []);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <div
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}
        >
          {trigger}
        </div>
      </PopoverTrigger>
      <PopoverContent 
        className={`${contentClassName} border-0`}
        align={align}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
